import { IMiniMachineState } from 'src/machines/shared';
import { useSelector } from '@xstate/react';
import usePolarisActor from 'src/hooks/usePolarisActor';

const optionalSelector = (state: IMiniMachineState) => {
  const actorId = state.context.actorId;
  return actorId?.includes('treatmentGuidance') || actorId?.includes('pxoc');
};

const useOptional = () => {
  const actor = usePolarisActor();

  return useSelector(actor as any, optionalSelector);
};

export default useOptional;
